// Marginal (tax-bracket) pricing for district/school license fees.
// Each rate applies only to students within its band. Total is capped at $55,000.

export const MARGINAL_TIERS = [
  { width: 10000, rate: 1.00 },
  { width: 10000, rate: 0.90 },
  { width: 10000, rate: 0.80 },
  { width: 10000, rate: 0.70 },
  { width: 10000, rate: 0.60 },
  { width: 10000, rate: 0.50 },
  { width: 10000, rate: 0.40 },
  { width: 10000, rate: 0.30 },
  { width: 10000, rate: 0.20 },
  { width: 10000, rate: 0.10 },
];

export const PRICE_CAP = 55000;
export const SMALL_SCHOOL_THRESHOLD = 100;

export function calculateEnrollmentPrice(enrollment) {
  const n = parseInt(enrollment) || 0;
  if (n < SMALL_SCHOOL_THRESHOLD) {
    return { price: 0, program: 'Small School Program', enrollment: n };
  }

  let remaining = n;
  let total = 0;
  for (const tier of MARGINAL_TIERS) {
    const take = Math.min(remaining, tier.width);
    total += take * tier.rate;
    remaining -= take;
    if (remaining <= 0) break;
  }

  const price = Math.min(Math.round(total), PRICE_CAP);
  return { price, program: price >= PRICE_CAP ? 'Enterprise (capped)' : 'Standard', enrollment: n };
}

export function calculatePartnerPrice(accountCount, attested) {
  const count = parseInt(accountCount) || 0;
  if (attested) {
    return { price: 0, program: 'Partner — Reading Disability Program (Free)', accounts: count };
  }
  return { price: count, program: 'Partner — Standard ($1/account)', accounts: count };
}

export function totalEnrollmentFromSchools(schools) {
  if (!Array.isArray(schools)) return 0;
  return schools.reduce((t, s) => t + (parseInt(s.totalEnrollment) || 0), 0);
}
